var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5102_18316",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5102_18316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6673 24.6663V27.4867C20.6673 27.8133 20.5523 28.0916 20.3223 28.3213C20.0925 28.5513 19.8143 28.6663 19.4877 28.6663H4.51365C4.18698 28.6663 3.90876 28.5513 3.67898 28.3213C3.44898 28.0916 3.33398 27.8133 3.33398 27.4867V17.846C3.33398 17.5193 3.44898 17.2411 3.67898 17.0113C3.90876 16.7813 4.18698 16.6663 4.51365 16.6663H8.66732V10.6663C8.66732 8.63212 9.38099 6.90134 10.8083 5.47401C12.2357 4.04667 13.9664 3.33301 16.0007 3.33301H21.334C23.3682 3.33301 25.099 4.04667 26.5263 5.47401C27.9537 6.90134 28.6673 8.63212 28.6673 10.6663V28.6663H26.6673V24.6663H20.6673ZM20.6673 22.6663H26.6673V10.6663C26.6673 9.19967 26.1451 7.94412 25.1007 6.89967C24.0562 5.85523 22.8007 5.33301 21.334 5.33301H16.0007C14.534 5.33301 13.2784 5.85523 12.234 6.89967C11.1895 7.94412 10.6673 9.19967 10.6673 10.6663V16.6663H19.4877C19.8143 16.6663 20.0925 16.7813 20.3223 17.0113C20.5523 17.2411 20.6673 17.5193 20.6673 17.846V22.6663ZM13.6673 12.9997V10.9997H23.6673V12.9997H13.6673ZM12.0007 22.4663L18.6673 18.6663H5.33398L12.0007 22.4663ZM12.0007 24.3123L5.33398 20.5123V26.6663H18.6673V20.5123L12.0007 24.3123Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostOffice);
export default __webpack_public_path__ + "static/media/post-office.93605fea54c5c20627902cb1e8c5558a.svg";
export { ForwardRef as ReactComponent };